import { ReactElement } from "react";
import { SkeletonFill } from "@/components";
import { SkeletonExperienceCard } from "./SkeletonExperienceCard";

export const ExperiencesListLoading = (): ReactElement => {

  return (
    <SkeletonFill count={4}>
      <SkeletonExperienceCard />
    </SkeletonFill>
  );
}